import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";


export class RewardApiService {
    private readonly rewardBaseUrl: string;

    constructor() {
        this.rewardBaseUrl = ApiConstants().reward;
    }

    async getRepeatableRewards(): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.rewardBaseUrl}repeatable`,
            requiresToken: true,
        });
        return response;
    }

    async getExceptionalRewards(skip: number, limit: number, filters: string[]): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.rewardBaseUrl}one-time`,
            requiresToken: true,
            params: {
                skip: skip,
                limit: limit,
                ...(filters.length > 0 && { categories: filters.join(',') })
            }
        });
        return response;
    }
} 